module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "hvr-grow",
    class: _vm.buttonStyle,
    style: (_vm.styleObject),
    attrs: {
      "aria-label": _vm.aria
    }
  }, [_vm._v(_vm._s(_vm.content))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c823165","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Button.vue
// module id = 962
// module chunks = 1